import { forwardRef, ComponentProps } from 'react'

export type AtomInputProps = ComponentProps<'input'>

export const AtomInput = forwardRef<HTMLInputElement, AtomInputProps>(
  ({ ...attr }: AtomInputProps, forwardedRef) => (
    <input {...attr} ref={forwardedRef} />
  ),
)
